/**
 * Account tab (top-right menu): the signed-in account's provider connections —
 * link Twitch/YouTube, reconnect, remove a provider, or delete the account.
 * Account-level, so it lives here rather than in a channel's Settings.
 */
import { useCallback, useEffect, useState } from "react";
import { api, type Me } from "../lib/api";
import { ConnectionsPanel } from "../components/ConnectionsPanel";
import { ConnectionsSkeleton } from "../components/Skeleton";

export function Account() {
  const [me, setMe] = useState<Me | null>(null);

  const loadMe = useCallback(() => {
    api.me().then(setMe).catch(() => setMe(null));
  }, []);
  useEffect(() => loadMe(), [loadMe]);

  if (!me) return <ConnectionsSkeleton />;
  return <ConnectionsPanel me={me} onChanged={loadMe} />;
}
